import { creditCardBrandOfAdyenBrand, adyenBrandOfCreditCardBrand } from '../../types-internal/AdyenTypes.js';

const RENDER_CONTAINER_ID = 'custom-card-container';
const styles = {
    base: {
        // same as the one for .z-input
        appearance: 'none',
        width: '100%',
        height: '100%',
        padding: '15px',
        minWidth: '0',
        color: '#555',
        lineHeight: '1.15',
        fontSize: '14px',
        fontFamily: 'sans-serif',
        fontWeight: '400',
    },
    error: {
        color: '#555',
    },
    validated: {
        color: '#555',
    },
};
function normalizeAdyenCardBrand(value) {
    if (typeof value === 'string') {
        const creditCardBrand = creditCardBrandOfAdyenBrand[value];
        return creditCardBrand ?? null;
    }
    else {
        return null;
    }
}
function getAdyenCardBrands(creditCardBrands) {
    const adyenCardBrands = [];
    for (const creditCardBrand of creditCardBrands) {
        const adyenCardBrand = adyenBrandOfCreditCardBrand[creditCardBrand];
        if (adyenCardBrand) {
            adyenCardBrands.push(adyenCardBrand);
        }
    }
    return adyenCardBrands;
}
// this is used to override adyen default i18n text,  this is also recommended by adyen to disable placeholders on the fields
// see https://docs.adyen.com/online-payments/web-components/localization-components
function overrideAdyenTranslations(t) {
    const requiredMessage = t('checkout.form.required.error');
    const cardNotSupported = t('checkout.payment.creditcard.type_not_supported');
    const invalidDate = t('checkout.payment.creditcard.expiry_date.invalid');
    return {
        'error.va.sf-cc-num.01': cardNotSupported,
        'error.va.sf-cc-num.02': requiredMessage,
        'error.va.sf-cc-num.03': cardNotSupported,
        'error.va.sf-cc-num.04': t('checkout.form.size.error', { '0': '4', '1': '23' }),
        'error.va.sf-cc-dat.01': invalidDate,
        'error.va.sf-cc-dat.02': invalidDate,
        'error.va.sf-cc-dat.03': invalidDate,
        'error.va.sf-cc-dat.04': requiredMessage,
        'error.va.sf-cc-dat.05': invalidDate,
        'error.va.sf-cc-mth.01': requiredMessage,
        'error.va.sf-cc-yr.01': requiredMessage,
        'error.va.sf-cc-yr.02': invalidDate,
        'error.va.sf-cc-cvc.01': requiredMessage,
        'error.va.sf-cc-cvc.02': t('checkout.form.invalid.error'),
        // emptying all placeholders
        'creditCard.numberField.placeholder': '',
        'creditCard.expiryDateField.placeholder': '',
        'creditCard.expiryDateField.month.placeholder': '',
        'creditCard.expiryDateField.year.placeholder': '',
        'creditCard.cvcField.placeholder': '',
        'creditCard.cvcField.placeholder.4digits': '',
        'creditCard.cvcField.placeholder.3digits': '',
    };
}

export { RENDER_CONTAINER_ID, getAdyenCardBrands, normalizeAdyenCardBrand, overrideAdyenTranslations, styles };
//# sourceMappingURL=AdyenCreditCardForm.static.js.map
